export default {"src":"/_next/static/media/sports12.c48fb110.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};